var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 47.5 47.5",
    viewBox: "0 0 47.5 47.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0v38Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b88c3",
    d: "M0 0a4 4 0 0 0-4-4h-28a4 4 0 0 0-4 4v28a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V0Z",
    transform: "translate(37 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0c1.365 0 2.42-.62 2.42-2.046 0-1.427-1.055-2.047-2.233-2.047h-10.356c-1.365 0-2.418.62-2.418 2.047 0 .65.402 1.209.712 1.581 2.574 3.069 5.365 5.861 7.721 9.271.558.806 1.086 1.767 1.086 2.883 0 1.271-.961 2.388-2.233 2.388-3.566 0-1.861-5.023-4.837-5.023-1.488 0-2.264 1.054-2.264 2.263 0 3.907 3.473 7.038 7.287 7.038s6.883-2.511 6.883-6.449C1.768 7.597-3.037 3.317-5.673 0H0Z",
    transform: "translate(24.086 12.093)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.2d1f3ea6f6b253f253af9d7762e23823.svg";
export { ForwardRef as ReactComponent };